(function(){
    'use strict';

    angular.module('elogbooks.common.service-routines', []);
})();
